// Global state
let byobCartAdd = [];
let byobCartArray = [];
let updateObj = {};
let byobNetTotal = 0;
let byobFullTotal = 0;
let applicableTier;
let numItems = 0;
let bundleId = new Date().getTime();
let maxDiscount = 0;

// Initialize cart on load
const getBYOBCart = () => {
  // Reset state
  byobCartAdd = [];
  byobCartArray = [];
  updateObj = {};
  byobNetTotal = 0;
  byobFullTotal = 0;
  bundleId = new Date().getTime();
  $('#byobItems').empty();

  $.getJSON('/cart.js', (cart) => {
    const byobCartItems = cart.items.filter(item =>
      item.properties && item.properties._byob_bundle
    );

    if (byobCartItems.length > 0) {
      byobCartItems.forEach(item => {
        byobCartArray.push(item);
        addLineBasket(
          item.final_price,
          item.original_price,
          item.quantity,
          item.product_title,
          item.variant_title,
          item.variant_id
        );
        numItems += item.quantity;
        byobFullTotal += item.original_price * item.quantity;
        byobNetTotal += item.final_price * item.quantity;
      });

      $('#byobCTATxt').text('Update Bundle ');
    }
  }).done(() => {
    qtySelectors();
    minItems(numItems);
    byobTrack();

    if (byobFullTotal > 0) {
      $('.byobTotal').html(
        ` <s class="hide">${formatPrice(byobFullTotal)}</s> ${formatPrice(byobNetTotal)}`
      );
    } else {
      $('.byobTotal').html('');
    }
  });
};

// Calculate max discount from tiers
if (typeof byobTiers !== 'undefined' && byobTiers.length > 0) {
  maxDiscount = Math.max(...byobTiers.map(tier => tier.discount_amount));
}

getBYOBCart();

// Form submission handler
$('.byobForm').submit(function(evt) {
  evt.preventDefault();
  evt.stopImmediatePropagation();

  const result = {};
  $.each($(this).serializeArray(), function() {
    result[this.name] = this.value;
  });

  $('.add-to-byob', this).text('ADDED');
  addBYOBItems(result);
});

// Add to cart CTA
$(document).on('click', '#addByobCTA', (evt) => {
  evt.preventDefault();
  evt.stopImmediatePropagation();
  addBYOBCart();
  $('#byob-cart').removeClass('active');
});

// Add items to basket
const addBYOBItems = (lineItem) => {
  byobFullTotal += Number(lineItem.quantity * lineItem.price);
  numItems += +lineItem.quantity;
  minItems(numItems);

  const itemPrice = lineItem.price * (1 - applicableTier.discount_amount / 100);

  addLineBasket(itemPrice, lineItem.price, lineItem.quantity, lineItem.title, lineItem.variant, lineItem.id);
  updateByobArray(lineItem.id, lineItem.quantity, lineItem.preorder);
  byobTrack();
  updateBasket();
  qtySelectors();
  $('#byobCTATxt').text('Add to Cart ');
};

// Update BYOB array with new/updated items
const updateByobArray = (id, qty, preorder, type = "plus") => {
  const found = byobCartArray.find(el => {
    if (el.variant_id == id) {
      el.quantity = type === "minus" ? el.quantity - +qty : el.quantity + +qty;
      const newPrice = el.price * (1 - applicableTier.discount_amount / 100);
      el.line_price = newPrice;
      byobNetTotal += newPrice * el.quantity;
    }
    return el.variant_id == id;
  });

  if (found) {
    updateObj[found.key] = found.quantity;
  } else {
    const byobCartfound = byobCartAdd.find(el => {
      if (el.id == id) {
        el.quantity = type === "minus" ? el.quantity - +qty : el.quantity + +qty;
      }
      return el.id == id;
    });

    if (!byobCartfound) {
      const cartItem = {
        quantity: parseInt(qty),
        id: id,
        properties: {
          'Bundle': "Build Your Own Bundle",
          '_byob_bundle': bundleId,
          '_grouping': bundleId
        }
      };

      if (preorder) {
        cartItem.properties['Ship Date'] = preorder;
      }

      byobCartAdd.push(cartItem);
    }
  }
};

// Add/update cart items
const addBYOBCart = () => {
  const promises = [];

  if (byobCartAdd.length > 0) {
    promises.push(
      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        data: { items: byobCartAdd },
        dataType: 'json',
        error: (error) => console.error('Add to cart error:', error)
      })
    );
  }

  if (Object.keys(updateObj).length > 0) {
    promises.push(
      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: { updates: updateObj },
        dataType: 'json',
        error: (error) => console.error('Update cart error:', error)
      })
    );
  }

  Promise.all(promises).then(() => {
    // Store BYOB full price in localStorage for insurance calculation
    localStorage.setItem('byob_full_price', byobFullTotal);
    getBYOBCart();
    ajaxCart.load();
  });
};

// Update basket prices and total
const updateBasket = () => {
  byobNetTotal = 0;

  $('.byobLine').each(function() {
    const qty = parseInt($(this).find('.itemQty').text());
    const newPrice = $(this).data('fullprice') * (1 - applicableTier.discount_amount / 100);
    byobNetTotal += newPrice * qty;
    $(this).find('.byobPrice').text(formatPrice(newPrice));
  });

  const totalHtml = byobFullTotal === byobNetTotal
    ? ` ${formatPrice(byobNetTotal)}`
    : ` <s class="hide">${formatPrice(byobFullTotal)}</s> ${formatPrice(byobNetTotal)}`;

  $('.byobTotal').html(totalHtml);
};

// Add line item to basket UI
const addLineBasket = (price, originalPrice, qty, title, variant, id) => {
  const source = $('#byobBasket').html();
  const template = Handlebars.compile(source);
  const data = {
    id: id,
    originalPrice: originalPrice,
    price: price,
    title: title,
    qty: qty,
    variant: variant,
    itemPrice: formatPrice(price),
    fullPrice: formatPrice(originalPrice),
    discountApplied: price !== originalPrice
  };

  $('#byobItems').append(template(data));
};

// Update tier tracking and messaging
const byobTrack = () => {
  applicableTier = byobTiers.find(tier => tier.threshold <= byobFullTotal);

  // Calculate tier difference (needed for messaging)
  const tierDiff = applicableTier.next_tier - byobFullTotal;

  // Frontend display steps (5 hardcoded visual markers matching the HTML)
  const frontendSteps = [0, 10, 15, 20, 25];

  // Helper function to get bar position for any discount percentage
  const getBarPosition = (discount) => {
    if (discount <= 0) return 0;
    if (discount >= 25) return 100;

    // Find which segment this discount falls in
    for (let i = 0; i < frontendSteps.length - 1; i++) {
      if (discount >= frontendSteps[i] && discount < frontendSteps[i + 1]) {
        const segmentWidth = 100 / (frontendSteps.length - 1); // 25% per segment
        const basePosition = i * segmentWidth;
        const progress = (discount - frontendSteps[i]) / (frontendSteps[i + 1] - frontendSteps[i]);
        return basePosition + (segmentWidth * progress);
      }
    }
    return 100;
  };

  const currentDiscount = applicableTier.discount_amount;
  const nextDiscount = applicableTier.next_discount || currentDiscount;

  let discountTier;

  if (currentDiscount >= 25 || !applicableTier.next_tier) {
    // At max tier, show 100%
    discountTier = 100;
  } else {
    // Get bar positions for current and next discount values
    const currentPosition = getBarPosition(currentDiscount);
    const nextPosition = getBarPosition(nextDiscount);

    // Calculate spending progress toward next tier (0 to 1)
    const spendingProgress = (byobFullTotal - applicableTier.threshold) / (applicableTier.next_tier - applicableTier.threshold);

    // Interpolate between current and next positions based on spending
    discountTier = currentPosition + ((nextPosition - currentPosition) * spendingProgress);
  }

  $("#byobTrack").animate({ width: `${discountTier}%` }, 1000);

  if (applicableTier) {
    let message = '';

    if (applicableTier.discount_amount === 0) {
      message = "Add 3 items to start bundling!";
    } else if (!applicableTier.next_discount) {
      message = `Yay, You're saving ${applicableTier.discount_amount}%!`;
    } else {
      message = `You're saving ${applicableTier.discount_amount}%! Only ${formatPrice(tierDiff)} away from saving ${applicableTier.next_discount}%.`;

      if (numItems < 3) {
        const howMany = 3 - numItems;
        message += `<br> Add ${howMany} more items to start saving`;
      }
    }

    $('#byobTierMsg').html(message);
  }
};

// Quantity selector handlers
const qtySelectors = () => {
  $('.byobQty svg').on('click', function(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    const variant = $(this).closest("tr[data-id]").attr('data-id');
    let qty = parseInt($(this).siblings('.itemQty').text());
    const fullPrice = parseInt($(this).closest(".byobLine").attr('data-fullprice'));

    if ($(this).hasClass('icon-plus')) {
      if (qty >= 15) return;
      byobFullTotal += fullPrice;
      qty += 1;
      numItems += 1;
      updateByobArray(variant, 1, undefined);
    } else {
      byobFullTotal -= fullPrice;
      qty -= 1;
      numItems -= 1;
      if (qty <= 0) qty = 0;
      updateByobArray(variant, 1, undefined, "minus");
    }

    $(this).siblings('.itemQty').text(qty);
    minItems(numItems);
    byobTrack();
    updateBasket();
  });
};

// Check minimum items requirement
const minItems = (qty) => {
  $('#addByobCTA').prop("disabled", qty < 3);
};

// Accordion header toggle
$('.byob-header').on('click', function() {
  $(this).parent().toggleClass('active');
  const $root = $('html, body');

  setTimeout(() => {
    $root.animate({ scrollTop: $(this).offset().top - 65 }, 500);
  }, 550);
});

// Details element handler
$('details').click(function() {
  $('details').not(this).removeAttr("open");
});

// Reset bundle
$('#resetByob').on('click', () => {
  byobCartArray.forEach(item => {
    updateObj[item.key] = 0;
  });

  $.ajax({
    type: "POST",
    url: '/cart/update.js',
    data: { updates: updateObj },
    dataType: 'json',
    success: () => {
      getBYOBCart();
      $('#byob-cart').removeClass('active');
      byobNetTotal = 0;
      byobFullTotal = 0;
      numItems = 0;
      byobTrack();
      $('.byobTotal').html('');
      $('#byobCTATxt').text('Add to Bundle');
      $('.add-to-byob:not([disabled])').text('Add to Bundle');
      $('.accordian-header').first().trigger('click');
    },
    error: (error) => console.error('Reset error:', error)
  });
});

// Modal close handler
$('.itemInfoModal .icon-close').on('click', function() {
  $(this).closest('.itemInfoModal').removeAttr('open');
});

// Mobile trigger
$('#mobTrigger').on('click', () => {
  $('#byob-cart').toggleClass('active');
});

// Product quantity adjusters
$('.product_item .js-qty__adjust').on('click', function() {
  const $el = $(this);
  const $qtySelector = $el.siblings().find('.js-qty__num');
  let qty = parseInt($qtySelector.val().replace(/\D/g, ''));

  if ($el.hasClass('js-qty__adjust--plus')) {
    if (qty >= 15) return;
    qty += 1;
  } else {
    qty -= 1;
    if (qty <= 1) qty = 1;
  }

  $qtySelector.val(qty);
});

// Tab switching
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.byobTab');
  const collections = document.querySelectorAll('.byobCollections');
  const byobCopy = document.querySelectorAll('.byobCopy');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      collections.forEach(c => c.classList.remove('active'));
      byobCopy.forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      collections[index].classList.add('active');
      byobCopy[index].classList.add('active');
    });
  });
});

// Variant selector change handler
$('[data-single-option-selector]').change(function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();

  const productSelected = $(this).parents('.product_item');
  const variant = getVariantFromOptions(productSelected);
  updateByobItem(productSelected, variant);
});

// Update BYOB item based on variant selection
const updateByobItem = (productSelected, variant) => {
  var variantImg = variant.featured_image.alt;
  var variantName = variant.name;

  // rug images, works with byob img alt
  if ( $('.rugAlt').length ) {
    $('.rugAlt').each(function() {
      const byobImgAltText = $(this).text();
      if (byobImgAltText) {
        if (byobImgAltText === variantName ) {
          variantImg = variantName
        }
      }
    });
  }

  $('[data-product-select]', productSelected)[0].value = variant.id;

  const selectedVariantStatus = productSelected.find('[data-product-select]').find(':selected').data('status');

  productSelected.find('.variant-title').text(variant.option1);
  productSelected.find('input[name="variant"]').attr('value', variant.title);
  productSelected.find('input[name="price"]').attr('value', variant.price);
  productSelected.find('.byobItemPrice').text(formatPrice(variant.price));
  productSelected.find('input[name="preorder"]').attr('value',
    productSelected.find('[data-product-select]').find(':selected').data('preorder')
  );
  productSelected.find('.variant-image').removeClass('selected');
  productSelected.find(`.variant-image[alt="${variantImg}"]`).first().addClass('selected');

  if (selectedVariantStatus) {
    productSelected.find('.add-to-byob').text('Add to bundle').attr('disabled', false);
  } else {
    productSelected.find('.add-to-byob').text('Sold Out').attr('disabled', true);
  }
};

// Get current selected options
const getCurrentOptions = (container) => {
  let currentOptions = $.map($('[data-single-option-selector]', container), function(element) {
    const $element = $(element);
    const type = $element.attr('type');

    if (type === 'radio' || type === 'checkbox') {
      if ($element[0].checked) {
        return {
          value: $element.val(),
          index: $element.data('index')
        };
      }
      return null;
    } else {
      return {
        value: $element.val(),
        index: $element.data('index')
      };
    }
  });

  return slate.utils.compact(currentOptions);
};

// Get variant from selected options
const getVariantFromOptions = (container) => {
  const product = JSON.parse($('[data-product-json]', container).html());
  const selectedValues = getCurrentOptions(container);
  const variants = product.variants;
  let found = null;

  variants.forEach((variant) => {
    let satisfied = true;

    selectedValues.forEach((option) => {
      if (satisfied) {
        satisfied = (option.value === variant[option.index]);
      }
    });

    if (satisfied) {
      found = variant;
    }
  });

  return found;
};

// Helper function to format prices consistently
const formatPrice = (price) => {
  return slate.Currency.formatMoney(price, theme.moneyFormat).replace(".00", "");
};
